<template>
  <div>
    <div v-wechat-title="'四周年纪念章'"></div>
    <div class="anniversary-pc-page">
      <div class="main"></div>
    </div>
  </div>
</template>
<script>
import { getTimeStamp } from "@/utils/utils";
import { mapActions } from "vuex";
export default {
  components: {},
  data() {
    return {
      enterLink: ""
    };
  },
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      // 分享
      const { protocol, host } = window.location;
      this.enterLink = `${protocol}//${host}/snail/four-anniversary/enter${getTimeStamp()}`;
      this.monitoringEquipment();
      this.isSetShare(this.enterLink);
    });
  },
  computed: {},
  methods: {
    monitoringEquipment() {
      if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
        location.href = this.enterLink;
      }
    },
    // 微信分享
    isSetShare(linkUrl) {
      this.setShare({
        link: linkUrl + `${getTimeStamp()}`,
        title: "最强蜗牛四周年纪念奖牌",
        imgUrl:
          "https://download4.qcplay.com/qcgame-api/AWhrzpeZARczrjaEKOrwo431bnHP4ZHCOy6zr0QP.png",
        desc: "最强蜗牛四周年限定纪念奖牌来袭！疯狂四周年，陪你一百年！"
      });
    },
    ...mapActions(["setShare"])
  }
};
</script>

<style lang="less">
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/anniversary/pc/index.vue